import { combineReducers } from 'redux';
import bim360integrationReducer from '../modules/bim360integration/bim360integration';
import registersReducer from '../modules/registers/reducers';

const rootReducer = combineReducers({
  bim360integration: bim360integrationReducer,
  register: registersReducer,
});

export default rootReducer;
